"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
exports.__esModule = true;
var BaseRepository_1 = require("./BaseRepository");
var UsersRepository = /** @class */ (function (_super) {
    __extends(UsersRepository, _super);
    function UsersRepository() {
        return _super.call(this, 'adm', 'users') || this;
    }
    UsersRepository.prototype._filter = function (e) {
        // anonymous is here - Maxim hates him
        return e.id != 0;
    };
    return UsersRepository;
}(BaseRepository_1.BaseRepository));
exports.UsersRepository = UsersRepository;
var DatasetsRepository = /** @class */ (function (_super) {
    __extends(DatasetsRepository, _super);
    function DatasetsRepository() {
        return _super.call(this, 'adm', 'datasets') || this;
    }
    DatasetsRepository.prototype._sort = function (es) {
        es.sort(function (e1, e2) {
            if (e1.srt !== e2.srt) {
                return e1.srt - e2.srt;
            }
            return e1.id - e2.id;
        });
    };
    return DatasetsRepository;
}(BaseRepository_1.BaseRepository));
exports.DatasetsRepository = DatasetsRepository;
var TopicsRepository = /** @class */ (function (_super) {
    __extends(TopicsRepository, _super);
    function TopicsRepository() {
        return _super.call(this, 'adm', 'topics') || this;
    }
    return TopicsRepository;
}(BaseRepository_1.BaseRepository));
exports.TopicsRepository = TopicsRepository;
var TopicDatasetMapsRepository = /** @class */ (function (_super) {
    __extends(TopicDatasetMapsRepository, _super);
    function TopicDatasetMapsRepository() {
        return _super.call(this, 'adm', 'topic_dataset_maps') || this;
    }
    return TopicDatasetMapsRepository;
}(BaseRepository_1.BaseRepository));
exports.TopicDatasetMapsRepository = TopicDatasetMapsRepository;
var UserGroupsRepository = /** @class */ (function (_super) {
    __extends(UserGroupsRepository, _super);
    function UserGroupsRepository() {
        return _super.call(this, 'adm', 'user_groups') || this;
    }
    return UserGroupsRepository;
}(BaseRepository_1.BaseRepository));
exports.UserGroupsRepository = UserGroupsRepository;
var DataSourceRepository = /** @class */ (function (_super) {
    __extends(DataSourceRepository, _super);
    function DataSourceRepository() {
        return _super.call(this, 'adm', '_data_sources') || this;
    }
    return DataSourceRepository;
}(BaseRepository_1.BaseRepository));
exports.DataSourceRepository = DataSourceRepository;
